import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import '@radix-ui/themes/styles.css';
// import '@radix-ui/colors';
// import '@radix-ui/themes/utilities.css';
// import '@styles/index.module.css';

import './styles/global.module.css';

import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from '@app/store';

import { App } from './Appplication';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        {/* <SentryProvider> */}
        <ReduxProvider store={store}>
            <PersistGate persistor={persistor} loading={<Suspense />}>
                <I18nextProvider i18n={i18n}>
                    <App />
                </I18nextProvider>
            </PersistGate>
        </ReduxProvider>
        {/* </SentryProvider> */}
    </StrictMode>,
);
